import {type} from '../utilities/type';
import {Action} from '@ngrx/store';
import {ServerForm, ServerFormUrl} from '../models/servers';

export const serverURLActionTypes = {
  LOAD: type('[ServerURL] Load'),
  LOAD_SUCCESS: type('[ServerURL] Load Success'),
  LOAD_FAIL: type('[ServerURL] Load ServerURL Error')
};

export class LoadServerURLAction implements Action {
  readonly type = serverURLActionTypes.LOAD;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}

export class LoadServerURLSuccessAction implements Action {
  readonly type = serverURLActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ServerFormUrl[]) {}
}

export class LoadServerURLFailAction implements Action {
  readonly type = serverURLActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
